module.exports = __webpack_public_path__ + "static/media/gato.94ffcb68.svg";